var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "dataset" }, [
    !_vm.isRoot
      ? _c("div", { staticClass: "pretext" }, [
          _vm.permission &&
          (!_vm.loaded ||
            _vm.root.datasets.length ||
            _vm.root.distributions.length ||
            _vm.root.groups.length)
            ? _c(
                "span",
                {
                  staticClass: "collapsible",
                  on: {
                    click: function ($event) {
                      return _vm.expand()
                    },
                  },
                },
                [
                  _vm.root.isExpanded
                    ? _c("i", { staticClass: "far fa-minus-square" })
                    : _c("i", { staticClass: "far fa-plus-square" }),
                ]
              )
            : _c("i", { staticClass: "far fa-square" }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "text" }, [
      !_vm.isRoot ? _c("i", { staticClass: "fa fa-database" }) : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          on: {
            click: function ($event) {
              return _vm.clickName()
            },
          },
        },
        [_vm._v(_vm._s(_vm.root.dsName))]
      ),
    ]),
    _vm._v(" "),
    _vm.root.isExpanded
      ? _c(
          "span",
          [
            _vm.loaded
              ? _c(
                  "span",
                  [
                    _c("sub-tree", {
                      attrs: { root: _vm.root },
                      on: { selectCrumbs: _vm.selectCrumbs },
                    }),
                  ],
                  1
                )
              : _c("Loading", { attrs: { "loading-message": "" } }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }